import { render, staticRenderFns } from "./sales-order-dashboard.vue?vue&type=template&id=4f954a04&scoped=true&"
import script from "./js/sales-order-dashboard.js?vue&type=script&lang=js&"
export * from "./js/sales-order-dashboard.js?vue&type=script&lang=js&"
import style0 from "./sales-order-dashboard.vue?vue&type=style&index=0&id=4f954a04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f954a04",
  null
  
)

export default component.exports